import React, { Component } from 'react'

import moment from 'moment'
import Icon from 'components/icon/icon'
import ProfilePicture from 'components/profile/profile-picture'
import ChatTitle from 'components/chat/title'

import {
	stripHtml
} from 'utils'

class MessageChat extends Component {
	ref = null

	state = {
		isVisible: false
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				isVisible: true
			})
		}, 1)
	}

	handleClick = () => {
		const {
			chatObject,
			createOrReturnChat,
			setCurrentBigChat
		} = this.props

		createOrReturnChat(chatObject)

		if (setCurrentBigChat) {
			setCurrentBigChat(chatObject.id)
		}
	}

	render() {
		const {
			chatObject,
			lastItem,
			lastUnreadItem,
			deleteChat,
			userData,
			entities,
			getRef,
			cellHeight,
			shouldRender,
			isCurrentBigChat
		} = this.props

		if (!chatObject || !chatObject.chat_items.length || !this.state.isVisible) {
			return null
		}

		let chatUsers = []

		let className = 'list-item'

		if (shouldRender) {
			if (lastUnreadItem) {
				className += ' unseen'
			}

			chatObject.userIds && chatObject.userIds.forEach(userId => {
				chatUsers.push(entities.users[userId])
			})
		} else {
			className += ' hidden'
		}

		if (isCurrentBigChat) {
			className += ` current-big-chat`
		}

		const displayedCreatedAt = lastItem ? moment(lastItem.created_at) : moment(chatObject.created_at)

		const isGif = lastItem && lastItem.message_text && lastItem.message_text.startsWith('<img') && lastItem.message_text.endsWith('/>') && lastItem.message_text.includes('.gif')

		return (
			<li
				className={className}
				onClick={this.handleClick}
				ref={ref => getRef(ref)}
				style={!shouldRender ? {
					height: cellHeight + 'px'
				} : null}
			>
				{shouldRender &&
					<span>
						{
							lastUnreadItem ?
								<i className="alert-dot"></i>
								: null
						}
						<ProfilePicture users={chatUsers} userData={userData} isTiny={true} />
						<div className="list-item-content">
							<h4>
								<ChatTitle
									chat={chatObject}
									userId={userData.id}
								/>
								{
									((chatObject.userIds && chatObject.userIds.length > 2) || chatUsers.length == 1) ?
										<div className="message-controls" onClick={e => { e.stopPropagation() }}>
											<button onClick={_ => { deleteChat(chatObject) }}>
												<Icon name="fe-trash-2" />
											</button>
										</div>
										: null
								}
								<time className="message-date">
									{displayedCreatedAt.format('Do MMM')}
								</time>
							</h4>
							<div>
								{lastItem ?
									lastItem.message_text ?
										isGif ?
											<p className="message-sub-file">
												<Icon name="fe-upload" />
												Sent a GIF
											</p>
											:
											<p>
												{stripHtml(lastItem.message_text)}
											</p>
										:
										<p className="message-sub-file">
											<Icon name="fe-upload" />
											{' ' + lastItem.filename}
										</p>
									:
									<p>
										(Empty chat)
									</p>
								}
							</div>
						</div>
					</span>
				}
			</li>
		)
	}
}

export default MessageChat


// WEBPACK FOOTER //
// ./src/layout/header/header-tabs/message-chat.jsx